(function($) {

    function handleMobileCategories() {
        if ($('.mobile_cat').length) {
            $('.mobile_cat').append('<ul class="menu-sidebar sub-menu menu"></ul>');
            $('#menu-menu-boczne > li').clone().appendTo('.mobile_cat > ul.menu-sidebar');
            $('.mobile_cat').addClass('active');
            $('.mobile_cat > ul').slideDown();

            $('.menu-sidebar').after('<div class="mobile_cat__scroll"></div>');

            $('.mobile_cat__scroll').on('click', () => {
                const $mobileCatMenu = $('.mobile_cat > ul');
                const scrollPos = $mobileCatMenu.scrollTop() + 160;

                $mobileCatMenu.animate({ scrollTop: scrollPos }, 'slow');
            });
        }
    }

    $(document).ready(() => {
        handleMobileCategories();
    });

    const initMobileHomepageSearch = () => {
        const isMobile = () => window.innerWidth <= 1024;
        const isHomepage = window.location.pathname === '/';

        if (isMobile() && isHomepage) {
            $('.header-mobile-search').css('display', 'block');
            $('.mini-search-menu a').addClass('active');
            $('.wrapper').toggleClass('bigger');
        }
    };

    $(document).ready(() => {
        initMobileHomepageSearch();
    });

    //after scrolling .sub-menu to end add class .scrolled
    //when scrolled on top add class .scrolled-top
    function setupSubmenuScrollWatcher() {
        const $subMenus = $('.header .header-main-nav ul.menu > li.menu-item-has-children ul.sub-menu');
        const $scrollButton = $('.mobile_cat__scroll');

        if ($subMenus.length === 0) return;

        $subMenus.on('scroll', function () {
            const $this = $(this);
            const scrollTop = $this.scrollTop();
            const visibleHeight = $this.innerHeight();
            const totalHeight = this.scrollHeight;

            const isAtBottom = scrollTop + visibleHeight >= totalHeight;
            const isAtTop = scrollTop === 0;

            if ($scrollButton.length) {
                $scrollButton.toggle(!isAtBottom);
            }

            $this.parent().toggleClass('scrolled-top', isAtTop);
        });
    }

    $(document).ready(() => {
        setupSubmenuScrollWatcher();
    });

    function isMobile() {
        return window.innerWidth <= 768;
    }

    function setupStickyHeader() {
        const $header = $('header');
        const $topBar = $('.header-top-bar');
        if (!$header.length) return;

        let lastScrollTop = 0;
        let ticking = false;

        $(window).on('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const scrollTop = $(window).scrollTop();
                    const shouldStick = isMobile() ? scrollTop >= 1 : scrollTop > 0;
                    
                    if ($header.hasClass('sticky') !== shouldStick) {
                        $header.toggleClass('sticky', shouldStick);
                    }

                    if (scrollTop === 0 && !$topBar.is(':visible')) {
                        $topBar.slideDown(200);
                    } else if (scrollTop > 0 && $topBar.is(':visible')) {
                        $topBar.slideUp(200);
                    }

                    lastScrollTop = scrollTop;
                    ticking = false;
                });
                ticking = true;
            }
        });
    }

    $(document).ready(() => {
        setupStickyHeader();
    });

})(jQuery);